import React, { useState, useRef, useEffect } from 'react';
import { Box, Button, ButtonGroup, IconButton, Tooltip, Typography } from '@mui/material';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import { Block } from '../new';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import CloseIcon from '@mui/icons-material/Close';

const TextEditor: React.FC<{ 
    index: number, 
    onChangeContent(content: string, i: number): void,
    handleRemove(): void,
    block: Block 
}> = ({ index, onChangeContent, handleRemove, block }) => {

    const [content, setContent] = useState<string>(block.content);
    const editorRef = useRef<HTMLDivElement>(null);
    const [fontSize, setFontSize] = useState<number>(16);

    useEffect(() => {
        if (editorRef.current) {
            editorRef.current.innerHTML = block.content;
        }
    }, []);

    const applyStyle = (command: string, value?: string) => {
        document.execCommand(command, false, value);
        updateContent();
    };

    const updateContent = () => {
        if (editorRef.current) {
            const newContent = editorRef.current.innerHTML;
            setContent(newContent);
            onChangeContent(newContent, index);
        }
    };

    return (
        <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <Box sx={{ display: "flex", width: "100%", justifyContent: "space-evenly", position: "relative" }}>
            <Box
                sx={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                }}
            >
                <Tooltip title="Fechar">
                    <IconButton color="warning" onClick={handleRemove}>
                        <CloseIcon />
                    </IconButton>
                </Tooltip>
            </Box>
                <Typography>Parágrafo {index + 1}</Typography>
                <ButtonGroup variant="contained" aria-label="text formatting buttons">
                    <Button color="warning" onClick={() => applyStyle('bold')}>
                        <FormatBoldIcon />
                    </Button>
                    <Button color="warning" onClick={() => applyStyle('underline')}>
                        <FormatUnderlinedIcon />
                    </Button>
                </ButtonGroup>
                <ButtonGroup variant="contained" aria-label="text alignment buttons">
                    <Button color="warning" onClick={() => applyStyle('justifyLeft')}>
                        <FormatAlignLeftIcon />
                    </Button>
                    <Button color="warning" onClick={() => applyStyle('justifyCenter')}>
                        <FormatAlignCenterIcon />
                    </Button>
                    <Button color="warning" onClick={() => applyStyle('justifyRight')}>
                        <FormatAlignRightIcon />
                    </Button>
                    <Button color="warning" onClick={() => applyStyle('justifyFull')}>
                        <FormatAlignJustifyIcon />
                    </Button>
                </ButtonGroup>
            </Box>

            <div
                ref={editorRef}
                onInput={updateContent}
                contentEditable
                className="edit-new-text"
                style={{
                    width: "100%",
                    padding: '10px',
                    marginTop: '10px',
                    minHeight: '1em',
                    fontSize: `${fontSize}px`,
                    direction: 'ltr'
                }}
            />
        </div>
    );
};

export default TextEditor;
